import React from 'react'
import { Checkbox, Input } from 'antd'
import styled from 'styled-components'

const OptionWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`

const PlacementFilter = ({
  PlacementData,
  handlePlacementChange,
  selectPlacement,
  handleInputChange,
}) => {
  const renderOptionInput = option => {
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <Input
          placeholder="From"
          style={{
            width: '80px',
            display: 'inline-block',
          }}
          disabled={selectPlacement !== option.value}
          value={option.fromValue}
          onChange={e => {
            const inputValue = e.target.value
            if (/^\d*$/.test(inputValue)) {
              handleInputChange('From', option.value, inputValue, option.status)
            }
          }}
        />
        -
        <Input
          placeholder="To"
          style={{
            width: '80px',
            display: 'inline-block',
          }}
          disabled={selectPlacement !== option.value}
          value={option.toValue}
          onChange={e => {
            const inputValue = e.target.value
            if (/^\d*$/.test(inputValue)) {
              handleInputChange('To', option.value, inputValue, option.status)
            }
          }}
        />
      </div>
    )
  }

  return (
    <div>
      {PlacementData.map(option => (
        <OptionWrapper key={option.value}>
          <Checkbox
            value={option.value}
            checked={selectPlacement === option.value}
            onChange={() => handlePlacementChange(option.value)}
          >
            {option.label}
          </Checkbox>
          {option.placeholder && renderOptionInput(option)}
        </OptionWrapper>
      ))}
    </div>
  )
}

export default PlacementFilter
